import { useState } from "react";
import {createContext,React} from "react";

export const DatabaseContext = createContext({

    isManagementOpen : false,
    isDesignOpen : false,
    isCodingOpen : false,
    isReportingOpen : false,
    setIsManagementOpen : () =>{},
    setIsDesignOpen : () =>{},
    setIsCodingOpen : () =>{},
    SetIsReportingOpen : () =>{},


});

export const DatabaseProvider = ({children}) => {
    
   const  [isManagementOpen , setIsManagementOpen] = useState(false);
   const  [isDesignOpen , setIsDesignOpen] = useState(false);
   const  [isCodingOpen , setIsCodingOpen] = useState(false);
   const  [isReportingOpen , SetIsReportingOpen] = useState(false);



    const value = {
            isManagementOpen,
            isDesignOpen,
            isCodingOpen,
            isReportingOpen,
            setIsManagementOpen,
            setIsDesignOpen,
            setIsCodingOpen,
            SetIsReportingOpen




    }

    return <DatabaseContext.Provider value= {value}>{children}</DatabaseContext.Provider>
} 